<script>
	import { createEventDispatcher } from 'svelte';
	import { MIN_DATE, MAX_DATE } from '../dateGuard.js';

	export let id;
	export let name;
	export let label;
	export let value = '';
	export let disabled = false;
	export let error = '';

	const dispatch = createEventDispatcher();
	let pickerInput;
	let text = toDisplay(value);
	let lastValue = value;

	$: if (value !== lastValue) {
		lastValue = value;
		text = toDisplay(value);
	}

	function toDisplay(iso) {
		if (!iso) return '';
		const [y, m, d] = iso.split('-');
		if (!y || !m || !d) return iso;
		return `${m}/${d}/${y}`;
	}

	function parseTyped(raw) {
		const m = raw.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4,6})$/);
		if (!m) return null;
		return `${m[3]}-${m[1].padStart(2, '0')}-${m[2].padStart(2, '0')}`;
	}

	function commit(iso) {
		pickerInput.value = iso;
		text = toDisplay(iso);
		dispatch('change', iso);
	}

	function handleChange() {
		if (text.trim() === '') { commit(''); return; }
		const iso = parseTyped(text);
		if (!iso) { dispatch('invalid'); return; }
		commit(iso);
	}

	function handlePick() {
		dispatch('input');
		commit(pickerInput.value);
	}

	function openPicker() {
		if (typeof pickerInput.showPicker === 'function') pickerInput.showPicker();
		else pickerInput.focus();
	}
</script>

<div class="relative">
	<input {id} type="text" inputmode="numeric" placeholder="MM/DD/YYYY" autocomplete="off" {disabled}
		class="input-field mt-4 pr-9 {error === '' ? '' : 'border-red-600'}"
		class:opacity-40={disabled}
		bind:value={text}
		on:input={() => dispatch('input')}
		on:change={handleChange}/>
	<input type="date" {name} {value} min={MIN_DATE} max={MAX_DATE} {disabled} tabindex="-1" aria-hidden="true"
		class="absolute right-0 bottom-0 w-px h-px opacity-0 pointer-events-none"
		bind:this={pickerInput}
		on:change={handlePick}/>
	<button type="button" aria-label="Open date picker" {disabled}
		class="absolute inset-y-0 right-0 mt-4 z-20 flex items-center pr-2 bg-transparent border-none text-gray-500 cursor-pointer disabled:cursor-default"
		class:opacity-40={disabled}
		on:click={openPicker}>
		<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
	</button>
	<label for={id} class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5">{label}</label>
</div>
<p class="error-text {error === '' ? 'hidden' : ''}">{error}</p>
